import type { U3142FindSearchCadastreItem } from '../../U3142Service';

/** Libellé suggestion cadastre avec district pour désambiguïser (BL-0067). */
export function u3142FindSearchCadastreItemToDisplay(item: unknown): string {
  if (!item || typeof item !== 'object') return '';
  const rec = item as U3142FindSearchCadastreItem;
  const cadastreLabel = [rec.cadastre, rec.cadastreCode].filter((v) => v != null && String(v).length > 0).join(' — ');
  const districtLabel = rec.district?.propertyDistrict ?? rec.district?.codeDistrict ?? '';
  if (cadastreLabel && districtLabel) return `${cadastreLabel} (${districtLabel})`;
  return cadastreLabel || districtLabel;
}
